// React
import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import ErrorIdentificationFeedbackArray from './components/ErrorIdentificationFeedbackArray';
import EmentorArray from '../shared/EmentorArray';

const ErrorIdentification = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir, possiblePages } = props;

  // Should this be deleted?
  // useEffect(() => {
  //   if (Object.keys(errors).length > 0) {
  //     console.log('%c🔥 Validation Errors:', 'color: red; font-weight: bold;');
  //     console.dir(errors, { depth: null });
  //   }
  // }, [errors]);

  return (
    <div>
      <NumberedHeading
        number="1"
        title="Questions"
        instructions="Using the controls below, please add questions for the activity"
      />
      <Controller
        control={control}
        name="content.core"
        render={({ field }) => (
          <ErrorIdentificationFeedbackArray
            inputDir={inputDir}
            materialPages={possiblePages}
            {...{ control, errors }}
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="2"
        title="eMentor Notes"
        instructions="Using the controls below, add any supplemental content to this page"
      />

      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default ErrorIdentification;
